export const undoIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10.42 6.67c-2.2 0-4.2.82-5.75 2.16l-3-3v7.5h7.5l-3.02-3c1.16-.97 2.63-1.57 4.27-1.57 2.95 0 5.46 1.93 6.33 4.58l1.98-.65c-1.16-3.5-4.44-6-8.3-6z"/></svg>`,
  name: 'undo',
};
